import { useEffect } from "react";
import { FormControl, TextField, Typography } from "@mui/material";

export const ReadOnlyInput = ({ placeholder, value }) => {
  const ariaLabel = placeholder.replace(" ", "_").toLowerCase();

  useEffect(() => {
    const input = document.getElementById(ariaLabel);
    if (input != null) input.setAttribute("aria-label", ariaLabel);
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Typography className="fieldLabel">
        {placeholder}
        {" *"}
      </Typography>
      <FormControl fullWidth>
        <TextField {...(placeholder != null && { id: ariaLabel })} size="small" variant="outlined" value={value} disabled />
      </FormControl>
    </>
  );
};
